import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { Analytics as VercelAnalytics } from '@vercel/analytics/react'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import Navbar from './components/Navbar'
import Sidebar from './components/Sidebar'
import Landing from './pages/Landing'

import Dashboard from './pages/Dashboard'
import Redemptions from './pages/Redemptions'
import CheckRedemptionValue from './pages/CheckRedemptionValue'
import CompareRedemption from './pages/CompareRedemption'
import Analytics from './pages/Analytics'
import Chatbot from './pages/Chatbot'
import Login from './pages/Login'
import Register from './pages/Register'
import LoadingSpinner from './components/LoadingSpinner'

function AppContent() {
  const { user, loading } = useAuth()
  const location = useLocation()

  // Add comprehensive logging
  // console.log('🚀 AppContent rendered')
  // console.log('📍 Current location:', location.pathname)
  // console.log('👤 User state:', user)
  // console.log('⏳ Loading state:', loading)

  if (loading) {
    // console.log('🔄 Showing LoadingSpinner')
    return <LoadingSpinner />
  }

  // Check if current route is the landing page, check redemption value page, compare redemption page, or dashboard page
  const isLandingPage = location.pathname === '/'
  const isCheckRedemptionPage = location.pathname === '/check-redemption-value'
  const isCompareRedemptionPage = location.pathname === '/compare-redemption'
  const isDashboardPage = location.pathname === '/dashboard'
  const shouldShowSidebar = !isLandingPage && !isCheckRedemptionPage && !isCompareRedemptionPage && !isDashboardPage

  // console.log('🎯 Route analysis:')
  // console.log('  - isLandingPage:', isLandingPage)
  // console.log('  - isCheckRedemptionPage:', isCheckRedemptionPage)
  // console.log('  - isCompareRedemptionPage:', isCompareRedemptionPage)
  // console.log('  - isDashboardPage:', isDashboardPage)
  // console.log('  - shouldShowSidebar:', shouldShowSidebar)

  // Show main app for both guests and authenticated users
  return (
    <div className="flex h-screen bg-gray-50">
      {shouldShowSidebar && <Sidebar />}
      <div className={'flex-1 flex flex-col overflow-hidden ' + (shouldShowSidebar ? 'ml-64' : '')}>
        {shouldShowSidebar && <Navbar />}
        <main className={'flex-1 overflow-x-hidden overflow-y-auto ' + (shouldShowSidebar ? 'bg-gray-50 p-6' : '')}>
          <Routes>
            <Route path="/" element={<Landing />} />

            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/redemptions" element={<Redemptions />} />
            <Route path="/check-redemption-value" element={<CheckRedemptionValue />} />
            <Route path="/compare-redemption" element={<CompareRedemption />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/chatbot" element={<Chatbot />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </div>
  )
}

function App() {
  // console.log('🚀 App component rendered')
  
  return (
    <Router>
      <AuthProvider>
        <AppContent />
        <VercelAnalytics />
      </AuthProvider>
    </Router>
  )
}

export default App
